// MiniDashboardWidget — compact credits balance + notification bell + user dropdown.
// Rendered only when a user is logged in. Credits are read from user context.
import React from "react";
import { useTranslation } from "react-i18next";
import { Coins } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import NotificationBellV3 from "./NotificationBellV3";
import AdminMegaDropdown from "./AdminMegaDropdown";

function formatCredits(n) {
    if (n == null) return "0";
    if (n >= 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, "")}k`;
    return String(n);
}

export default function MiniDashboardWidget() {
    const { t } = useTranslation("header_v3");
    const { user } = useAuth();
    if (!user || user === false) return null;

    const credits = user.credits ?? user.credit_balance ?? 0;

    return (
        <div className="flex items-center gap-2" data-testid="header-v3-mini-dashboard">
            {/* Credits pill */}
            <div
                className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-white/5"
                style={{ backgroundColor: "rgba(255, 255, 255,0.08)" }}
                data-testid="header-v3-credits-pill"
                title={t("credits.tooltip")}
            >
                <Coins className="w-3.5 h-3.5" style={{ color: "#FFFFFF" }} aria-hidden />
                <span className="text-xs font-semibold text-white tabular-nums">
                    {formatCredits(credits)}
                </span>
            </div>
            <NotificationBellV3 />
            <AdminMegaDropdown user={user} />
        </div>
    );
}
